module.exports = __webpack_public_path__ + "static/img/slide2.21a816a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide2.jpg
// module id = ClwB
// module chunks = 7